import Client from "@memaro/api"
import {tokenRetriever} from "./auth.ts"

export default new Client(import.meta.env.VITE_API_ENDPOINT, tokenRetriever)
